
export default {
	name: 'returnKey',
	handler: {
		init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
			ko.utils.registerEventHandler(element, 'keydown', function (evt) {
				if (evt.keyCode === 13)
				{
					evt.preventDefault();
					valueAccessor().call(viewModel);
				}
			});
		}
	}
};
